export interface PaymentFilters {
  dateRange: {
    start: string | null;
    end: string | null;
  };
  status: PurchaseStatus | null;
  userId: string | null;
  userName: string | null;
  paymentItem: string | null; 
}
export interface PurchaseConcept {
  id: string;
  Name: string;
  Amount: number;
  studentId?: string;
}

export interface PaymentConcept{
  id: string;
  name: string;
  description?: string;
  amount: number;
  studentId?: string;
  studentName?: string;
  cant: number;
  active?: boolean;
}

export interface PaymentsOptions{
  concepts:[PaymentConcept],
}

export interface PaymentItem {
  id: string;
  name: string;
  cant: number ;
  amount: number;
  category?: string;
  active?: boolean;
  createdAt?: string; // Changed from Timestamp to string for Redux compatibility
  description?: string
  studentId?: string
}

export enum PurchaseStatus{
  PENDING = 'pending',
  COMPLETED = 'completed',
  APPROVED = 'approved',
  FAILED = 'failed',
  REJECTED = 'rejected'
}

export interface Payment {
    id: string;
    amount: number;
    createdAt: string;
    customerEmail: string;
    customerName: string;
    customerNameLower?: string;
    customerPhone: string;
    customerAddress?: string;
    customerCity?: string;
    description: string;
    concepts: PaymentConcept[];
    conceptIds?: string[];
    isAuthenticated: boolean;
    referenceCode: string;
    status: PurchaseStatus;
    userId: string | null;
    site?: string;
}


export interface PaymentMethod {
  type: 'credit' | 'debit' | 'pse' | 'efecty' | 'baloto' | 'puntoRed' | 'suSuerte' | 'corresponsal';
  label: string;
}

export interface PaginationInfo {
  currentPage: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  lastVisible: any | null;   
  firstVisible: any | null;   
  cursors: Record<number, {
    firstDoc: any;
    lastDoc: any;
  }>;
  totalPagesKnown: number;
}

export interface FetchPurchasesParams {
  filters: PaymentFilters;
  pageSize?: number;
  direction?: 'next' | 'previous';
  lastVisible?: any;
  firstVisible?: any;
}

export interface FetchPurchasesResult {
  data: Payment[];
  lastVisible: any;
  firstVisible: any;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  currentPage: number;
}
